<template><div><h1>VUX V2.1.1Rc.3 released</h1>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Add font-size variable #990 @wg5945</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[fix] Fix nodes list forEach function is undefined #991 @howyhuang</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul><li>[fix] Fix no loading style if not using Loading component #986 @malaimoo</li>
</ul>
<h2><a href="/en/components/ajax.html">Ajax</a></h2>
<ul><li>[feature] Export http on Vue</li>
</ul>
<h2><a href="/en/components/wechat.html">Wechat</a></h2>
<ul><li>[feature] Export wechat on Vue</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.3 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.3-92.vue?b5e25f08